import './copperkitchen/style';
import FormStructure from './copperkitchen/form_structure';

export default FormStructure;